import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';

import Layout from '../../components/Layout/Layout'
import OrgManager from '../../sections/OrgManagers/OrgManagers'

class OrgManagers extends Component {
    render() {
        const { t } = this.props;
		const transPage = 'sidebar.'
        return (
            <Layout title={t(transPage + 'organization_managers')}>
                <OrgManager />
            </Layout>
        )
    }
}
export default withTranslation()(OrgManagers);

